// extracted by mini-css-extract-plugin
export default {"cls1":"VeloProgressIndicator-Bar_cls1__SQm5g","cls2":"VeloProgressIndicator-Bar_cls2__jgqNV VeloProgressIndicator-Bar_cls1__SQm5g"};